import React, { useState } from 'react';
import {
  Row, Col, Button, Collapse,
} from 'react-bootstrap5';

import routes from 'app/routes';
import AffiliateBadge from 'images/new_ui/affiliates/badge.png';
import IconWithText from 'components/Widgets/IconWithText';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function Certificate() {
  const { state: stateUsers } = useUsersContext();
  const [open, setOpen] = useState(false);

  const affiliate = stateUsers.user.attributes.specific;
  const trainingNotCompleted = affiliate.training_completion !== 100;

  return (
    <>
      <Row>
        <Col>
          <div className="icon-with-text">
            <div className="icon-bg bg-tertiary-1000">
              <i className="star-filled-icon" />
            </div>

            <div className="text-content ms-3">
              <Button
                variant="link"
                className="fs-4 text-decoration-none text-gray-900 fw-semibold"
                onClick={() => setOpen(!open)}
                aria-controls="certificate-collapse"
                aria-expanded={open}
              >
                Certificate
              </Button>
            </div>
          </div>
        </Col>

        <Col xs="auto">
          <Button
            variant="light"
            className="ms-3 p-0"
            style={{ borderRadius: '50%', borderBottomLeftRadius: '0' }}
            onClick={() => setOpen(!open)}
            aria-controls="certificate-collapse"
            aria-expanded={open}
          >
            <IconWithText
              iconClassName="chevron-icon small-icon"
              wrapperClassName="p-2"
            />
          </Button>
        </Col>
      </Row>

      <Collapse in={open}>
        <div
          id="certificate-collapse"
          className="mt-2 p-3 border border-2 rounded-3"
          style={{ marginLeft: '4rem' }}
        >
          <Row>
            <Col>
              <IconWithText
                iconClassName="picture-icon"
                iconStyle={{ backgroundImage: `url(${AffiliateBadge})`, minHeight: '128px', minWidth: '128px' }}
                wrapperClassName="d-block d-md-flex text-center text-md-start"
              >
                <p className="fw-semibold">
                  This badge proves that you have successfully completed the affiliate training program.
                </p>

                <p>
                  Click the Download button when you training program is completed.
                  <br />
                  You will also get a copy of the badge in an email automatically.
                </p>
              </IconWithText>
            </Col>

            <Col lg="auto" className="mt-3 mt-lg-0 text-center">
              <a
                href={routes.affiliates.training.certificate}
                className={`btn btn-primary ${trainingNotCompleted && 'disabled'}`}
              >
                Download
              </a>
            </Col>
          </Row>
        </div>
      </Collapse>
    </>
  );
}
